import ReactGA from "react-ga4";
import * as api from "api";

export const getSmapSoilsAsync = {
    send: (features, existingSoilFeatures) => (dispatch) => {
        (features || []).forEach((f) => {
            delete f.properties.errorWindow;
            delete f.scrollRef;
        });

        (existingSoilFeatures || []).forEach((f) => {
            delete f.properties.errorWindow;
            delete f.scrollRef;
        });

        return new Promise((resolve, reject) => {
            ReactGA.event({
                category: "Soils",
                action: "Get Smap Soils",
            });
            dispatch(
                api.post({
                    path: `soil/smap`,
                    timeout: 300000,
                    content: { features, existingSoilFeatures },
                    onSuccess: (response) => {
                        resolve(response);
                        return [];
                    },
                    onFailure: (error) => {
                        error.handled = true;
                        reject("Error loading S-Map soils");
                        return [];
                    },
                    cancelActionType: "abort_getSmapSoilsAsync",
                })
            );
        });
    },
    abort: () => (dispatch) => dispatch({ type: "abort_getSmapSoilsAsync" }),
};

export const getSmapSoilByRefAsync = {
    send: (smapReference) => (dispatch) => {
        return new Promise((resolve, reject) => {
            ReactGA.event({
                category: "Soils",
                action: "Get Soil by SMAP ref",
            });
            dispatch({ type: "abort_getSmapSoilByRefAsync" });
            dispatch(
                api.get({
                    path: `soil/smap/${smapReference}`,
                    timeout: 300000,
                    onSuccess: (response) => {
                        resolve(response);
                        return [];
                    },
                    onFailure: (error) => {
                        error.handled = true;
                        reject("Error loading S-Map soil");
                        return [];
                    },
                    cancelActionType: "abort_getSmapSoilByRefAsync",
                })
            );
        });
    },
    abort: () => (dispatch) => dispatch({ type: "abort_getSmapSoilByRefAsync" }),
};
